import { render } from "./LoanApp.vue?vue&type=template&id=18427a79"
import script from "./LoanApp.vue?vue&type=script&lang=js"
export * from "./LoanApp.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__